import { z } from "zod";

export const loginFormSchema = z.object({
    email: z
        .email({
            message: "A valid email is required",
        })
        .min(1, {
            message: "Email is required",
        }),
    password: z
        .string({
            message: "Password is required",
        })
        .min(1, {
            message: "Password is required",
        }),
    rememberMe: z.boolean(),
});
